const Retry = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M8.33333 14.6668C8.33333 14.6668 8.8995 14.5859 11.2426 12.2428C13.5858 9.89966 13.5858 6.10067 11.2426 3.75752C10.4125 2.92734 9.39952 2.39129 8.33333 2.14938M8.33333 14.6668H12.3333M8.33333 14.6668L8.33333 10.6668M5.66667 1.33363C5.66667 1.33363 5.1005 1.41451 2.75736 3.75765C0.414213 6.1008 0.414213 9.89979 2.75736 12.2429C3.58754 13.0731 4.60048 13.6092 5.66667 13.8511M5.66667 1.33363L1.66667 1.3335M5.66667 1.33363L5.66667 5.3335"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Retry;
